import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { toast } from 'sonner';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await login(email, password);
      toast.success('Suksesvol aangemeld');
      navigate('/dashboard');
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Aanmelding het misluk');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen py-24 md:py-32 px-6 md:px-12 flex items-center justify-center">
      <div className="w-full max-w-md">
        <h1 className="font-heading text-4xl md:text-5xl font-normal tracking-tight text-charcoal mb-8 text-center">
          Teken Aan
        </h1>

        <div className="bg-parchment border border-[#E5E0D6] p-8 md:p-12">
          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <label className="block font-ui text-sm uppercase tracking-widest text-charcoal mb-2">
                E-pos
              </label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                data-testid="login-email"
                className="w-full bg-transparent border-b border-charcoal/20 focus:border-gold px-0 py-4 text-xl font-body placeholder:text-charcoal/40 outline-none transition-colors"
                placeholder="u.epos@voorbeeld.com"
              />
            </div>

            <div>
              <label className="block font-ui text-sm uppercase tracking-widest text-charcoal mb-2">
                Wagwoord
              </label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                data-testid="login-password"
                className="w-full bg-transparent border-b border-charcoal/20 focus:border-gold px-0 py-4 text-xl font-body placeholder:text-charcoal/40 outline-none transition-colors"
                placeholder="••••••••"
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              data-testid="login-submit"
              className="w-full bg-charcoal text-parchment hover:bg-charcoal/80 rounded-sm px-8 py-4 font-ui uppercase tracking-widest text-sm transition-colors duration-300 disabled:opacity-50"
            >
              {loading ? 'Besig...' : 'Teken Aan'}
            </button>
          </form>

          <div className="mt-8 text-center space-y-4">
            <p className="font-body text-lg text-muted-charcoal">
              <Link to="/forgot-password" data-testid="link-to-forgot-password" className="text-gold hover:underline">
                Wagwoord vergeet?
              </Link>
            </p>
            <p className="font-body text-lg text-muted-charcoal">
              Het u nog nie 'n rekening nie?{' '}
              <Link to="/register" data-testid="link-to-register" className="text-gold hover:underline">
                Registreer hier
              </Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
